import React, { useState } from 'react'
import Picker from 'emoji-picker-react'
import { Button, makeStyles, Popover } from '@material-ui/core'
import { SentimentSatisfiedAlt } from '@material-ui/icons'
import { styles } from './styles'

const EmojiPicker = ({ onEmojiClick, className }) => {
  const useStyles = makeStyles(theme => styles)
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const onClickButton = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={className || ''}>
      <Button className={classes.button} onClick={onClickButton}>
        <SentimentSatisfiedAlt fontSize="small" />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Picker className={classes.picker} onEmojiClick={onEmojiClick} />
      </Popover>
    </div>
  )
}

export default EmojiPicker
